import { CanDeactivateFn } from '@angular/router';
import { EditPetInfoPageComponent } from "../pages/edit-pet-info-page/edit-pet-info-page.component";
import { PetFnolPageComponent } from "../pages/pet-fnol-page/pet-fnol-page.component";
import { EditInsuranceInfoPageComponent } from "../pages/edit-insurance-info-page/edit-insurance-info-page.component";

export const editInfoCanDeactivateGuard: CanDeactivateFn<unknown> = (component) => {
  return (component as EditPetInfoPageComponent | PetFnolPageComponent | EditInsuranceInfoPageComponent).canDeactivate ? (component as EditPetInfoPageComponent).canDeactivate() : true;
};
